module.exports = __webpack_public_path__ + "static/media/PackageHoldLogo.0ba1c6b8.png";